import { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { LuCalendarPlus, LuPencil, LuMegaphone, LuHome, LuUserPlus, LuLogOut, LuUserCircle } from "react-icons/lu";
import "../../styles/backOffice/backOfficeMainPage.css"

import CreateEvents from "./createEvents";
import EditEvents from "./editEvents";
import CreateFlashNews from "./createFlashNews";
import ManageAccounts from "./manageAccounts";
import { AUTH_LOGOUT } from "../../reducers/authReducer";


//PAGES DU BACK OFFICE, regroupées par section (pour ajouter une page : une ligne dans "pages")
//"adminOnly" : section visible uniquement par les administrateurs (le serveur vérifie aussi le rôle)
const SECTIONS = [
  {
    title: "Événements",
    pages: [
      { id: "createEvent", label: "Créer un événement", icon: LuCalendarPlus, component: CreateEvents },
      { id: "editEvent", label: "Modifier un événement", icon: LuPencil, component: EditEvents },
    ],
  },
  {
    title: "Flash News",
    pages: [
      { id: "flashNews", label: "Gérer les Flash News", icon: LuMegaphone, component: CreateFlashNews },
    ],
  },
  {
    title: "Comptes",
    adminOnly: true,
    pages: [
      { id: "accounts", label: "Créer un compte", icon: LuUserPlus, component: ManageAccounts },
    ],
  },
];

const ROLE_LABELS = { administrator: "Administrateur", contributor: "Contributeur" };

function BackOfficeMainPage() {

  const auth = useSelector((state) => state.authReducer);
  const dispatch = useDispatch();

  //Sections accessibles selon le rôle de l'utilisateur connecté
  const isAdministrator = auth?.user?.role === "administrator";
  const sections = SECTIONS.filter((section) => !section.adminOnly || isAdministrator);
  const allPages = sections.flatMap((section) => section.pages);

  const [activePageId, setActivePageId] = useState(allPages[0].id);
  const activePage = allPages.find((page) => page.id === activePageId) || allPages[0];
  const ActiveComponent = activePage.component;

  const openPage = (id) => {
    setActivePageId(id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <main className="bo">

      {/* EN-TÊTE */}
      <header className="page-hero bo-hero">
        <div className="wrap page-hero_content bo-hero_content">
          <div>
            <p className="page-hero_eyebrow">
              <span className="tricolor" aria-hidden="true"><span></span><span></span><span></span></span>
              Espace membres
            </p>
            <h1 className="page-hero_title bo-hero_title">Back-office</h1>
          </div>
          <div className="bo-hero_actions">
            {auth?.user && (
              <p className="bo-hero_user">
                <LuUserCircle aria-hidden="true" />
                <span><strong>{auth.user.firstName} {auth.user.lastName}</strong> · {ROLE_LABELS[auth.user.role]}</span>
              </p>
            )}
            <Link to="/" className="btn btn--outline-light bo-hero_link">
              <LuHome aria-hidden="true" /> Voir le site
            </Link>
            <button type="button" className="btn btn--light bo-hero_link" onClick={() => dispatch({ type: AUTH_LOGOUT })}>
              <LuLogOut aria-hidden="true" /> Se déconnecter
            </button>
          </div>
        </div>
      </header>

      <div className="wrap bo-layout">

        {/* MENU : latéral sur ordinateur, onglets défilables sur mobile */}
        <nav className="bo-nav" aria-label="Menu du back-office">
          {sections.map((section) => (
            <div key={section.title} className="bo-nav_group">
              <p className="bo-nav_group_title">{section.title}</p>
              <ul className="bo-nav_list">
                {section.pages.map(({ id, label, icon: Icon }) => (
                  <li key={id}>
                    <button
                      type="button"
                      className="bo-nav_item"
                      aria-current={id === activePageId ? "page" : undefined}
                      onClick={() => openPage(id)}
                    >
                      <Icon className="bo-nav_icon" aria-hidden="true" />
                      {label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav>

        {/* PAGE SÉLECTIONNÉE */}
        <div className="bo-content">
          <ActiveComponent />
        </div>
      </div>
    </main>
  )
};

export default BackOfficeMainPage;
